import {
  ActionMenuItem,
  isAction,
  isActionGroup,
  isLinkItem,
  isRouteItem,
  isSelectableAction,
  Item,
  ItemVariant,
  LinkListItem,
  RouteMenuItem,
  SelectableItem,
} from "shared-ts-ui-action";
import React, { ReactNode } from "react";
import { Layout } from "../../../Layout";
import { LayoutDirection } from "../../../LayoutDirection";
import { GroupMenu } from "./GroupMenu";
import { GroupList } from "../list/GroupList";
import { PopoverOrigin } from "@mui/material";

export interface RenderItemParams {
  variant?: ItemVariant;
  layout: Layout;
  layoutDirection?: LayoutDirection;
  item: Item;
  index?: number;
  onSelected?: (item: SelectableItem) => void;
  hideSelection?: boolean;
  disableTextInset?: boolean;
  childComponentPreferences?: {
    groupMenu?: {
      anchorOrigin?: PopoverOrigin;
      transformOrigin?: PopoverOrigin;
    };
  };
}

export const renderMenuItem = (params: RenderItemParams): ReactNode => {
  const { variant, layout, layoutDirection, item, onSelected } = params;
  const index = params.index ?? 0;
  const handleItemSelected = (item: SelectableItem) => {
    onSelected?.(item);
  };

  if (isSelectableAction(item)) {
    return (
      <ActionMenuItem
        key={index}
        item={item}
        variant={variant}
        layout={layout}
        layoutDirection={layoutDirection}
        hideSelection={params.hideSelection}
        disableTextInset={params.disableTextInset}
      />
    );
  } else if (isRouteItem(item)) {
    return (
      <RouteMenuItem
        key={index}
        item={item}
        variant={variant}
        layout={layout}
        layoutDirection={layoutDirection}
        onSelected={handleItemSelected}
      />
    );
  } else if (isLinkItem(item)) {
    return (
      <LinkListItem
        key={index}
        item={item}
        variant={variant}
        layout={layout}
        layoutDirection={layoutDirection}
      />
    );
  } else if (isAction(item)) {
    return (
      <ActionMenuItem
        key={index}
        item={item}
        variant={variant}
        layout={layout}
        layoutDirection={layoutDirection}
      />
    );
  } else if (isActionGroup(item)) {
    if (item.preferences?.displayInline === true) {
      return (
        <GroupList
          variant={variant}
          layout={layout}
          key={index}
          item={item}
          onSelected={onSelected}
          hideLabels={item.preferences?.hideLabels ?? true}
        />
      );
    } else {
      return (
        <GroupMenu
          variant={variant}
          layout={layout}
          key={index}
          item={item}
          onSelected={onSelected}
          hideSelected={true}
          disableTextInset={params.disableTextInset}
          anchorOrigin={
            params.childComponentPreferences?.groupMenu?.anchorOrigin
          }
          transformOrigin={
            params.childComponentPreferences?.groupMenu?.transformOrigin
          }
        />
      );
    }
  } else {
    throw new Error("Unsupported type: \n" + item.type);
  }
};
